import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsLoggedIn } from "@/auth/authSlice";
import useEntitlements from "@/auth/useEntitlements";

export default function ProtectedComponents({ permission, children }) {
    const navigate = useNavigate(); // need this instance for this component to work
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const { hasPermission: checkPermission } = useEntitlements();
    const hasPermission = permission ? checkPermission(permission) : true;

    if (!isLoggedIn || (permission && !hasPermission)) {
        return null;
    }

    return children;
}
